import {
  apiFetch,
  clearRefreshToken,
  setRefreshToken,
  setToken,
} from "./client";

interface LoginRequest {
  email: string;
  password: string;
}

interface LoginResponseData {
  access_token: string;
  refresh_token?: string;
  expires_in: number;
  user: {
    id: string;
    email: string;
    display_name: string;
    custom_id: string | null;
  };
}

export async function login(
  credentials: LoginRequest,
): Promise<LoginResponseData> {
  const res = await apiFetch<{ data: LoginResponseData }>("/admin-auth/login", {
    method: "POST",
    body: JSON.stringify({
      email: credentials.email,
      account_password: credentials.password,
    }),
  });
  setToken(res.data.access_token);
  if (res.data.refresh_token) {
    setRefreshToken(res.data.refresh_token);
  } else {
    clearRefreshToken();
  }
  return res.data;
}
